<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}<span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n2">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.role')"
                                id="role"
                                type="text"
                                ref="role"
                                :rules="[rules.required]"
                                v-model="formData.role"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="9" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('roleassignment.description')"
                                id="roledesc"
                                type="text"
                                ref="roledesc"
                                :rules="[rules.required]"
                                v-model="formData.roledesc"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <v-row>
                                <v-col cols="4" class="pb-n4 mt-n8">
                                    <v-checkbox
                                        ref="systemrole"
                                        v-model="formData.systemrole"
                                        :label="this.$t('workflowrole.systemrole')"
                                        @change="updateValue"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="4" class="pb-n4 mt-n8">
                                    <v-checkbox
                                        ref="issupervisory"
                                        v-model="formData.issupervisory"
                                        label="Supervisory"
                                        @change="updateValue"
                                    ></v-checkbox>
                                </v-col>
                                <v-col cols="4" class="pb-n4 mt-n8">
                                    <v-checkbox
                                        ref="isdisable"
                                        v-model="formData.isdisable"
                                        :label="this.$t('columns.disable')"
                                        @change="updateValue"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="9" class="pb-n4 mt-n7">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.remark')"
                                id="remarks"
                                type="text"
                                ref="remarks"
                                v-model="formData.remarks"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                </v-container>


                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit
                    v-on:SavePressed="saveHandler" 
                    v-on:CancelPressed="cancelHandler" />

            </v-form>

        </v-container>
    </div>
</template>

<script>

export default {
    props: {
        parentObject: Object
    },

    data() {
        return {
            formData: {
                role: this.parentObject.data.role,
                roledesc: this.parentObject.data.roledesc,
                systemrole: this.parentObject.data.systemrole,
                issupervisory: this.parentObject.data.issupervisory,
                isdisable: this.parentObject.data.isdisable,
                remarks: this.parentObject.data.remarks,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },

            rules: { required: value => !!value || this.$t('reportsparam.required') },
            errMsg: '',
            isErr: false,
        }
    },

    methods: {

        updateValue() {
            this.$emit('input', {
                role: this.formData.role,
                roledesc: this.formData.roledesc,
                systemrole: this.formData.systemrole,
                issupervisory: this.formData.issupervisory,
                isdisable: this.formData.isdisable,
                remarks: this.formData.remarks,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        saveHandler() {
            this.$emit('save');
        },

        cancelHandler() {
            this.$router.push({name: 'wfrolelist'});
        }
    },
}
</script>